import { useState, useEffect } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': faqItems.map((item) => ({
        '@type': 'Question',
        'name': item.question,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': item.answer,
        },
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'faq-schema';
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('faq-schema');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-accent-600 font-semibold mb-3 block">
            Perguntas Frequentes
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
            Dúvidas sobre os tratamentos? A Dra. Marihana responde
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-xl mx-auto leading-relaxed">
            Do siso ao sorriso dos sonhos, esclarecemos as principais dúvidas sobre cada tratamento oferecido no consultório da Faria Lima.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <div className="flex-1 pr-4">
                  <span className="inline-block text-[11px] uppercase tracking-wider font-semibold text-accent-700 bg-accent-100/80 px-2.5 py-1 rounded-full mb-2">
                    {item.category}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    {item.question}
                  </h3>
                </div>
                <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-primary-500 text-white rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-400 ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-600 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}